module.exports = __webpack_public_path__ + "img/tapesthree.ecddb507.png";